import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  position: relative;\n\n  /* Dot */\n  &::before {\n    position: absolute;\n    display: block;\n    width: 8px;\n    height: 8px;\n\n    background-color: var(\n      ", "\n    );\n    border-radius: 50%;\n    transform: scale(1);\n    transform-origin: 50%;\n\n    transition: ", " var(", ");\n    transition-property: transform background-color;\n\n    content: '';\n  }\n\n  /* Dot checked */\n  &:checked::before {\n    background-color: var(\n      ", "\n    );\n    transform: scale(1.5);\n  }\n\n  /* Dot readonly */\n  &[readonly]::before {\n    background-color: var(\n      ", "\n    );\n  }\n\n  /* Dot readonly */\n  &[readonly]:checked::before {\n    background-color: var(\n      ", "\n    );\n  }\n\n  /* Dot invalid */\n  &:invalid::before {\n    background-color: ", ";\n  }\n\n  /* Dot disabled */\n  &:disabled::before {\n    background-color: var(\n      ", "\n    );\n  }\n\n  /* Dot disabled checked */\n  &:disabled:checked::before {\n    background-color: var(\n      ", "\n    );\n  }\n\n  /* Dot invalid checked */\n  &:invalid:checked::before {\n    background-color: ", ";\n  }\n\n  /* Dot hover */\n  &:enabled:not([readonly]):not(:checked):hover::before {\n    background-color: var(\n      ", "\n    );\n    transform: scale(1.25);\n  }\n\n  /* Dot checked:hover */\n  &:enabled:not([readonly]):checked:hover::before {\n    transform: scale(1.25);\n  }\n\n  /* Dot checked:hover */\n  &:enabled:not([readonly]):checked:valid:hover::before {\n    background-color: var(\n      ", "\n    );\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { StyledInput, fadeDuration } from '../GenericOption/GenericOption.styles';
export var StyledRadioButton = styled(StyledInput).attrs({
  type: 'radio'
})(_templateObject(), function (props) {
  return props.theme.colors.interaction.tertiary.default;
}, fadeDuration, function (props) {
  return props.theme.easing;
}, function (props) {
  return props.theme.colors.interaction.secondary.filled;
}, function (props) {
  return props.theme.colors.interaction.tertiary.default;
}, function (props) {
  return props.theme.colors.interaction.secondary.filled;
}, function (props) {
  return props.invalid && "var(".concat(props.theme.colors.interaction.tertiary.default, ")");
}, function (props) {
  return props.theme.colors.interaction.tertiary.disabled;
}, function (props) {
  return props.theme.colors.interaction.tertiary.disabled;
}, function (props) {
  return props.invalid && "var(".concat(props.theme.colors.ui.error, ")");
}, function (props) {
  return props.theme.colors.interaction.tertiary.hover;
}, function (props) {
  return props.theme.colors.interaction.secondary.filled;
});